/** Sous-navigation de la boîte : liens et onglet courant, sous les droits effectifs. */
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import styles from '../inventaire/InventairePage.module.css';

export function NavigationBoite({ courante }: { courante: 'boite' | 'relances' | 'assistant' }) {
  const { galerieSlug, galerie } = useShellContext();

  const { t } = useTranslation('regie');

  if (!galerieAModule(galerie, 'assistant-reponse')) return null;

  return (
    <nav className={styles.onglets} aria-label={t('assistantReponse.navigation')}>
      {galerieALaction(galerie, 'inbox:read') && (
        <>
          <Link
            to={`/${galerieSlug}/boite-reception`}
            aria-current={courante === 'boite' ? 'page' : undefined}
          >
            {t('boiteReception.titre')}
          </Link>
          <Link
            to={`/${galerieSlug}/boite-reception?vue=relances`}
            aria-current={courante === 'relances' ? 'page' : undefined}
          >
            {t('assistantReponse.relances')}
          </Link>
        </>
      )}
      {galerieALaction(galerie, 'inbox:settings') && (
        <Link
          to={`/${galerieSlug}/boite-reception/assistant`}
          aria-current={courante === 'assistant' ? 'page' : undefined}
        >
          {t('assistantReponse.assistant')}
        </Link>
      )}
    </nav>
  );
}
